import { webPortalApi } from '#config/web-portal-api';
import { FilterOption } from '#service/autocomplete-service/option';
import { getRequestOptions } from '#helper';

class ApplianceFilterOptionService {
  #searchFields;

  constructor(searchFields) {
    if (!searchFields?.length) {
      throw new Error('Search fields are not provided');
    }

    this.#searchFields = searchFields;
  }

  async fetchOptionsRaw(value, fetchOptions = {}, ids) {
    const searchParams = new URLSearchParams({
      limit: 50,
      order: 'asc',
      orderBy: 'label',
      offset: 0,
      pagination: 1
    });

    if (value) {
      searchParams.set('filter', value);
      searchParams.set('filterBy', this.#searchFields);
    }

    if (ids) {
      searchParams.set('id', ids);
    }

    const devicesURL = webPortalApi.buildApiUrl(`warehouse/appliance?${searchParams.toString()}`);
    const res = await fetch(devicesURL, { ...getRequestOptions(), ...fetchOptions });
    const contentType = res.headers.get('content-type');

    if (!contentType || !contentType.includes('application/json')) {
      throw new TypeError('Response is not json');
    }

    const r = res.json();

    if (!res.ok) {
      throw await r;
    }

    return r;
  }

  async getOptions(value, fetchOptions, ids) {
    const fetchedOptions = await this.fetchOptionsRaw(value, fetchOptions, ids);
    const transformedOptions = this.transformOptions(fetchedOptions);

    return transformedOptions;
  }

  transformOptions(options) {
    return options?.appliances?.map(option => {
      const label = `${option.label}`;
      return new FilterOption(option, label);
    });
  }
}
export default ApplianceFilterOptionService;
